import { Construction } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { EmptyState } from './EmptyState';
import { PageHeader } from './PageHeader';

interface Props {
  title: string;
  description?: string;
  /** Coming-soon note shown in the body. */
  note?: ReactNode;
}

/**
 * Stub for modules whose backend exists but the React UI has not been
 * implemented yet. Lets the route be reachable from the sidebar without
 * 404'ing during the staged rebuild.
 */
export function PlaceholderPage({ title, description, note }: Props) {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader
        title={t(title, title)}
        description={description ? t(description, description) : undefined}
      />
      <EmptyState
        icon={Construction}
        title={t('common.coming_soon', 'Module under construction')}
        description={
          note ??
          t(
            'common.coming_soon_description',
            'This screen is part of the staged rebuild. The Laravel API endpoint already exists; the React UI ships in a later phase.',
          )
        }
      />
    </>
  );
}
